const initialLinkSettings = 1
const LINK_PREFERENCES = 'linkPreferences'

export {
    initialLinkSettings,
    LINK_PREFERENCES
}